//公共模版
const stenManageZh = {
  stenManageLang: {
    公共模版: '公共模版',
    电价模版: '电价模版',
    请输入内容例如模版名称标签: '请输入内容，例如模版名称、标签',
    查询: '查询',
    重置: '重置',
    创建模板: '创建模板',
    模版名称: '模版名称',
    标签: '标签',
    创建人: '创建人',
    创建时间: '创建时间',
    操作: '操作',
    查看: '查看',
    引用创建: '引用创建',
    编辑: '编辑',
    是否确认删除该模板: '是否确认删除该模板？',
    删除: '删除',
    暂无数据: '暂无数据',
    模板详情: '模板详情',
    模板名称: '模板名称',
    模板标签: '模板标签',
    开始时间: '开始时间',
    结束时间: '结束时间',
    时段: '时段',
    买入电价元kWh: '买入电价(元/kWh)',
    卖出电价元kWh: '卖出电价(元/kWh)',
    尖: '尖',
    峰: '峰',
    平: '平',
    谷: '谷',
    确定: '确定',

    模版编辑: '模版编辑',
    基础信息: '基础信息',
    时段与电价: '时段与电价',

    请输入模版名称: '请输入模版名称',
    标签名称: '标签名称',
    请输入标签名称: '请输入标签名称',
    生成: '生成',
    '标签名称以空格分隔，完成后回车或点击“生成”按钮即可生成标签。每个标签最多可输入20个字符，最多支持生成10个标签':
      '标签名称以空格分隔，完成后回车或点击“生成”按钮即可生成标签。每个标签最多可输入20个字符，最多支持生成10个标签。',
    标签管理: '标签管理',
    取消: '取消',
    点击编辑后可以勾选标签后进行删除操作: '点击“编辑”后，可以勾选标签后，进行删除操作',
    确定修改: '确定修改',
    下一步: '下一步',
    最多还可添加: '最多还可添加',
    个标签: '个标签',
    单个标签字符长度不可超过20: '单个标签字符长度不可超过20',
    请选择要删除的标签: '请选择要删除的标签',
    时间编辑: '时间编辑',
    选择时间: '选择时间',
    时段说明: '时段说明',
    请选择: '请选择',
    新增: '新增',
    电价编辑: '电价编辑',
    买入价格: '买入价格',
    元: '元',
    卖出价格: '卖出价格',
    确定添加: '确定添加',
    请选择开始时间: '请选择开始时间',
    开始时间不可与结束时间相同: '开始时间不可与结束时间相同',
    选择结束时间: '选择结束时间',
    结束时间不可与开始时间相同: '结束时间不可与开始时间相同',
    请选择时间段类型: '请选择时间段类型',
    请输入买入价格: '请输入买入价格',
    '买入价格数字范围 0 - 10000': '买入价格数字范围 0 - 10000',
    小数点后不允许超过9位: '小数点后不允许超过9位',
    请输入卖出价格: '请输入卖出价格',
    '卖出价格数字范围 0 - 10000': '卖出价格数字范围 0 - 10000',
    时间段存在冲突请重新配置: '时间段存在冲突,请重新配置！',
    主动绑定: '主动绑定',
    确认: '确认',
    选择年月: '选择年月',
    选择年份: '选择年份',
    请选择: '请选择',
    全部: '全部',
    选择电站: '选择电站',
    选择地区: '选择地区',
    未绑定电站: '未绑定电站',
    已选: '已选',
    请输入内容: '请输入内容',
    '01月': '1月',
    '02月': '2月',
    '03月': '3月',
    '04月': '4月',
    '05月': '5月',
    '06月': '6月',
    '07月': '7月',
    '08月': '8月',
    '09月': '9月',
    '10月': '10月',
    '11月': '11月',
    '12月': '12月',
    '请确认主动绑定的年份、月份、电站均已配置': '请确认主动绑定的年份、月份、电站均已配置！',
    提示: '提示',
    '当前配置信息如下，请确认是否绑定': '当前配置信息如下，请确认是否绑定！',
    年: '年',
    电站: '电站',
    月: '月',
    年月: '年月',
    请选择绑定月份: '请选择绑定月份！',
    请选择绑定电站: '请选择绑定电站！'
  }
}
export default stenManageZh
